module.exports = __webpack_public_path__ + "static/ellen-armstrong-pic-top-f29fb28eecb14f42a4c919b18215e768.jpg";